import { LogsService } from "@/services/logs/logs.service";

const _logsService = new LogsService();

const getUserLogsInCampusAction = (
  { commit },
  { superSpaceId, page, callback }
) => {
  _logsService
    .getUserLogsInCampus(superSpaceId, page)
    .then((response) => {
      callback(response);
    })
    .catch((err) => {
      console.log(err);
    });
};

const getUserLogsInSpaceAction = ({ commit }, { spaceId, page, callback }) => {
  _logsService
    .getUserLogsInSpace(spaceId, page)
    .then((response) => {
      callback(response);
    })
    .catch((err) => {
      console.log(err);
    });
};

const getLogsWithQueryAction = ({ commit }, { query, page, callback }) => {
  _logsService
    .getLogsWithQuery(query, page)
    .then((response) => {
      callback(response);
    })
    .catch((err) => {
      console.log(err);
    });
};

const downloadCsvAction = ({ commit }, { type, id, from, to, callback }) => {
  _logsService
    .downloadCsv(type, id, from, to)
    .then((response) => {
      const downloadLink = document.createElement("a");
      const blob = new Blob(["\ufeff", response.data]);
      const url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = "data.csv";

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      callback(response);
    })
    .catch((err) => {
      console.log(err);
    });
};

const sendGraphicClientErrorAction = ( { commit }, { data, callback, callbackError })  => {
  _logsService
    .sendGraphicClientError(data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

export default {
  getUserLogsInCampusAction,
  getUserLogsInSpaceAction,
  getLogsWithQueryAction,
  downloadCsvAction,
  sendGraphicClientErrorAction,
};
